import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'sushi-swap'),
  es: flattenMessages(es, 'sushi-swap'),
  ru: flattenMessages(ru, 'sushi-swap'),
  zh: flattenMessages(zh, 'sushi-swap'),
};
